import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.667 7.333c.368 0 .667.299.667.667v2.667a.667.667 0 0 1-.667.666h-2A.667.667 0 0 1 4 10.667V8c0-.368.298-.667.667-.667zM5.334 10H6V8.667h-.666z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.333 12.667v-8a1.335 1.335 0 0 1 1.334-1.334h4l.134.014a.667.667 0 0 1 0 1.306l-.134.014h-4v8h10.666v-8h-4a.667.667 0 0 1 0-1.334h4a1.335 1.335 0 0 1 1.334 1.334v8A1.334 1.334 0 0 1 13.333 14H2.667a1.335 1.335 0 0 1-1.334-1.333"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.334 2.667v2h1.333v-2zm2.666 2A1.333 1.333 0 0 1 8.667 6H7.334A1.335 1.335 0 0 1 6 4.667v-2a1.335 1.335 0 0 1 1.334-1.334h1.333A1.334 1.334 0 0 1 10 2.667zM10.666 10l.135.013a.667.667 0 0 1 0 1.307l-.135.014H9.333a.667.667 0 0 1 0-1.334zM12 7.333l.134.014a.667.667 0 0 1 0 1.306L12 8.667H9.333a.667.667 0 0 1 0-1.334z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })